(() => {
  const BRHModal = () => {
    const init = () => {
      const closeIcon = document.querySelector(".js-brh-modal-section .js-btn-close");
      const modalContainer = document.querySelector(".js-brh-modal-section .js-brh-modal-container");

      closeIcon.onclick = () => {
        closeIcon.closest(".js-brh-modal-section").style.display = "none";
        modalContainer.innerHTML = "";
        document.body.classList.remove("mod--menu-open");
      };
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHModal);
})();
